import config from "../config";
import { authHeader } from "../helpers";

const getAllProfiles = (query) => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  if (query) {
    return fetch(
      `${config.atsApiUrl}/job/all?${new URLSearchParams(query)}`,
      requestOptions
    ).then(handleResponse);
  } else {
    return fetch(`${config.atsApiUrl}/job/all`, requestOptions).then(
      handleResponse
    );
  }
};

const getAllReferral = () => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${config.atsApiUrl}/candidate/all/referrals`, requestOptions).then(
    handleResponse
  );
};

const createProfile = (createData) => {
  const formData = new FormData();

  for (const name in createData) {
    formData.append(name, createData[name]);
  }
  const requestOptions = {
    method: "POST",
    headers: {
      ...authHeader(),
    },
    body: formData,
  };

  return fetch(`${config.atsApiUrl}/job/create`, requestOptions).then(
    handleResponse
  );
};

const updateProfile = (updateData, id) => {
  const formData = new FormData();

  for (const name in updateData) {
    formData.append(name, updateData[name]);
  }
  const requestOptions = {
    method: "PUT",
    headers: {
      ...authHeader(),
    },
    body: formData,
  };

  return fetch(`${config.atsApiUrl}/job/update/${id}`, requestOptions).then(
    handleResponse
  );
};

const deleteProfile = (id) => {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
  };

  return fetch(`${config.atsApiUrl}/job/delete/${id}`, requestOptions).then(
    handleResponse
  );
};
//assignee
const getAssignee = (query) => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  if (query) {
    return fetch(
      `${config.atsApiUrl}/job/assignee?${new URLSearchParams(query)}`,
      requestOptions
    ).then(handleResponse);
  } else {
    return fetch(`${config.atsApiUrl}/job/assignee`, requestOptions).then(
      handleResponse
    );
  }
};

//getcluster
const getCluster = (query) => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  if (query) {
    return fetch(`${config.authApiUrl}/cluster${query}`, requestOptions).then(
      handleResponse
    );
  } else {
    return fetch(`${config.authApiUrl}/cluster`, requestOptions).then(
      handleResponse
    );
  }
};

//getSearch
//old-api call before 14 April
const getSearchApi = (query) => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  if (query) {
    return fetch(
      `${config.authApiUrl}/auth/search${query}`,
      requestOptions
    ).then(handleResponse);
  } else {
    return fetch(`${config.authApiUrl}/auth/search`, requestOptions).then(
      handleResponse
    );
  }
};

const getAuthSearch = (query) => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  if (query) {
    return fetch(
      `${config.atsApiUrl}/job/assignee${query}`,
      requestOptions
    ).then(handleResponse);
  } else {
    return fetch(`${config.atsApiUrl}/job/assignee`, requestOptions).then(
      handleResponse
    );
  }
};

//get jobProfiles
const getMasterData = (type) => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  if (type) {
    return fetch(
      `${config.atsApiUrl}/job/master_data?type=${type}`,
      requestOptions
    ).then(handleResponse);
  } else {
    return fetch(`${config.atsApiUrl}/job/master_data`, requestOptions).then(
      handleResponse
    );
  }
};

//get job Ids
const getjobIds = () => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${config.atsApiUrl}/job/profiles`, requestOptions).then(
    handleResponse
  );
};

//get all cities
const getCities = (country) => {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ country }),
  };

  return fetch(`${config.citiesApiUrl}`, requestOptions).then(
    handleResponse
  );
}

const handleResponse = (response) => {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error = (data && data.message) || response.statusText;
      if(response.status == 401){
        localStorage.clear()
        window.location.pathname = '/'
      }
      return Promise.reject(error);
    }
    return data;
  });
};

export const jobProfileService = {
  getAllProfiles,
  createProfile,
  updateProfile,
  deleteProfile,
  getAssignee,
  getMasterData,
  getjobIds,
  getCluster,
  getAuthSearch,
  getCities,
  getSearchApi,
  getAllReferral
};
